import useTranslate from '~/hooks/useTranslate';
import { Badge, Body, Group } from '@qred/components-library';
import { BADGE_COLOR_GREY_300, BADGE_COLOR_PRIMARY_800 } from './constants';
import React from 'react';
import { Step } from '~/store/types/updateApplication';
import { getStepName } from './utils/getStepName.utils';

type StepGroupProps = {
  stepIsFinished: boolean;
  stepName: Step;
};

const StepGroup = ({ stepIsFinished, stepName }: StepGroupProps) => {
  const t = useTranslate();

  return (
    <Group
      data-testid="update-application-step-group"
      key={stepName}
      align="center"
      justify="space-between"
      w="100%"
      nowrap
    >
      <Body align="left" data-record>
        {t(getStepName(stepName))}
      </Body>
      <Badge
        color={stepIsFinished ? BADGE_COLOR_PRIMARY_800 : BADGE_COLOR_GREY_300}
        size="sm"
        data-record
      >
        {stepIsFinished
          ? t('UpdateApplication.StepComplete')
          : t('UpdateApplication.StepIncomplete')}
      </Badge>
    </Group>
  );
};

export default StepGroup;
